export const USER_BASE_URL =
  "https://m.np.playstation.com/api/userProfile/v1/internal/users";

export const USER_GAMES_BASE_URL =
  "https://m.np.playstation.com/api/gamelist/v2/users";

export const USER_LEGACY_BASE_URL =
  "https://us-prof.np.community.playstation.net/userProfile/v1/users";

export const USER_CPSS_BASE_URL = 
  "https://m.np.playstation.com/api/cpss";
